import { FormattedMessage } from "react-intl";

const InformationPanel = (): JSX.Element => {
  return (
    <div className="row">
      <div className="card info-card">
        <div className="card-header">
          <FormattedMessage id="info-title" />
        </div>
        <div className="card-body">
          <p>
            <FormattedMessage id="info-text-chargebacks-left" />
          </p>
          <p>
            <FormattedMessage id="additional-info-text-left" />
            <a href="https://support-leagueoflegends.riotgames.com/hc/articles/4403733573011">
              <FormattedMessage id="info-ticket-link-1" />
            </a>
            <FormattedMessage id="additional-info-text-right" />
          </p>
        </div>
      </div>
    </div>
  );
};

export default InformationPanel;
